import type { DueKind, TaskStatus } from '@ovo/shared'
import { daysBetween, formatDue, isPast, overdueText } from '../lib/dates.ts'
import { isOpen } from '../lib/status.ts'
import { IconClock } from './icons.tsx'

interface DeadlineLabelProps {
  dueAt: string | null
  dueKind?: DueKind
  status: TaskStatus
  isOverdue?: boolean
  now?: Date
  /** Показывать «без срока», если срока нет. */
  showNone?: boolean
}

/** Срок задачи: «сегодня, 18:00», «пт, 9 окт, 18:00»; если прошёл — мягко: «срок прошёл вчера». */
export function DeadlineLabel({
  dueAt,
  dueKind = 'datetime',
  status,
  isOverdue,
  now = new Date(),
  showNone,
}: DeadlineLabelProps) {
  if (!dueAt) return showNone ? <span className="deadline deadline--none">без срока</span> : null
  const active = isOpen(status) && status !== 'submitted'
  if (active && (isOverdue || isPast(dueAt, now))) {
    return (
      <span className="deadline deadline--overdue">
        <IconClock size={14} strokeWidth={2} />
        {overdueText(dueAt, now)}
      </span>
    )
  }
  const today = active && daysBetween(now, new Date(dueAt)) === 0
  return (
    <span className={`deadline${today ? ' deadline--today' : ''}`}>
      <IconClock size={14} strokeWidth={2} />
      <time dateTime={dueAt}>{formatDue(dueAt, dueKind, now)}</time>
    </span>
  )
}
